/* eslint-disable max-len */
import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Deal } from 'ng2-app/models/dto/deal.model';
import { Approval } from 'ng2-app/models/dto/approval/approval.model';

@Component({
  selector: 'app-deal-details',
  templateUrl: './deal-details.component.html',
  styleUrls: ['./deal-details.component.scss'],
  standalone: false
})

export class DealDetailsComponent implements OnChanges {
  @Input() deal: any;
  @Input() approvals: Approval[] = [];
  @Input() advancedDeal: boolean = false;

  sbaStatus = '';
  sbaStatusTooltipText = '';
  sbaStatusTooltips = {
    'Duplicate Submission': 'The SBA reported this application as a duplicate submission.',
    'Failed to Connect': 'Failed to connect to the SBA. Please try to resubmit through Lender Portal in a few minutes.',
    'Failed Validation': 'Application did not pass SBA validation. Please check the PPP Application Blockers for details.',
    'Loan Canceled': 'This submission has been removed from the SBA platform because the associated loan was canceled in E-Tran',
    'Incomplete': 'This file is missing required information that must be corrected before SBA submission. Check the PPP Application Blockers for details.',
    'Submitted': 'Sent to the SBA',
    'Withdrawn from SBA': 'This submission has been withdrawn from the SBA platform.',
  };

  constructor() { }

  ngOnChanges(changes: SimpleChanges) {
    const { sba_status: statusObj = null } = this.deal || {};

    if (!!statusObj) {
      const { withdrawn = false, sbaLoanNumber = null, sbaStatus = '' } = statusObj;

      if (withdrawn) {
        this.sbaStatus = sbaLoanNumber ? 'Loan Canceled' : 'Withdrawn from SBA';
      } else {
        this.sbaStatus = sbaStatus;
      }

      this.sbaStatusTooltipText = this.sbaStatusTooltips[this.sbaStatus] || '';
    }

  }

}
